import React from 'react';
import { Link } from 'react-router';
import { observer } from 'mobx-react';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import ExamDetails from '../Modules/ExamDetails';
import ExamDetailedInfo from '../Modules/ExamDetailedInfo';
import StudentStatus from '../Modules/StudentStatus';

const InstructorExamCard = observer(class InstructorExamCard extends React.Component {
  renderProctorApprovals = exam => {
    const { onOpenApprovals, translation } = this.props;

    return (
      <a
        className="notification"
        href="#ApproveProctor"
        onClick={e => onOpenApprovals(e, exam.sid)}
      >
        <div className="tooltip tooltip--right">
          <icons.iconUsers />

          <div
            className="tooltip__body tooltip__body--brief"
            id={`approve-${exam.sid}-tooltip`}
            role="tooltip"
          >
            {translation.pending_approval}
          </div>
        </div>

        <em className="notification__count">{exam.pendingApprovals}</em>
      </a>
    )
  }

  render() {
    const {
      exam,
      onLockExam,
      onOpenEvents,
      onUnlockExam,
      store,
      translation
    } = this.props;
    const { SessionStore, SettingsStore } = store;
    const { userData } = SessionStore;
    const { settings } = SettingsStore;

    return (
      <article className="panel">
        <header className="panel__header">
          <h3 className="panel__title">
            <i className="panel__icn">
              {exam.type.toLowerCase() === 'online' ? <icons.iconLaptop /> : <icons.iconPencilPaper />}
            </i>

            {exam.title}
          </h3>

          <div className="panel__tools">
            {exam.pendingApprovals > 0 &&
              <FeatureFlag
                flagKey="instructor-proctor-approval"
                renderFeatureCallback={() => this.renderProctorApprovals(exam)}
              />
            }

            {exam.openSessionEvents > 0 &&
              <a
                className="notification notification--warn"
                href="#IncidentReport"
                onClick={e => onOpenEvents(e, exam.sid)}
              >
                <div className="tooltip tooltip--right">
                  <icons.iconExclamation />

                  <div
                    className="tooltip__body tooltip__body--brief"
                    id={`incident-${exam.sid}-tooltip`}
                    role="tooltip"
                  >
                    {translation.open_incidents}
                  </div>
                </div>

                <em className="notification__count">{exam.openSessionEvents}</em>
              </a>
            }

            {exam.configuration.locked &&
              <span
                className="notification"
              >
                <div className="tooltip tooltip--right">
                  <icons.iconLock />

                  <div
                    className="tooltip__body"
                    id={`locked-${exam.sid}-tooltip`}
                    role="tooltip"
                  >
                    {translation.exam_locked}
                  </div>
                </div>
              </span>
            }

            {exam.configuration.apiExamId &&
              <span
                className="notification"
              >
                <div className="tooltip tooltip--right">
                  <icons.iconCloudDownload />

                  <div
                    className="tooltip__body"
                    id={`imported-${exam.sid}-tooltip`}
                    role="tooltip"
                  >
                    {translation.exam_imported}
                  </div>
                </div>
              </span>
            }
          </div>
        </header>

        <div className="panel__body">
          {!exam.configuration.approved &&
            <div className="cta cta--negative">
              <strong className="cta__copy">{translation.pending_cta.heading}</strong>
              <span className="cta__subcopy">{translation.pending_cta.body}</span>
            </div>
          }

          <StudentStatus
            {...this.props}
            i={exam.sid}
            summary={exam.statusSummary}
            limitedScope={exam.isLimitedScope}
          />

          <ExamDetails
            {...this.props}
            exam={exam}
            scheduleWindow={true}
          />

          <ExamDetailedInfo
            {...this.props}
            exam={exam}
          />

          <footer className="panel__actions actions">
            <SessionStore.validater>
              {/* Admin unlock exam button */}
              {
                exam.configuration.locked &&
                userData.role.toLowerCase() === 'administrator' &&

                <button
                  className="actions__btn actions__btn--secondary"
                  onClick={() => onUnlockExam(exam.sid, exam.configuration.sid)}
                >
                  <icons.iconUnlock />
                  {translation.unlock}
                </button>
              }

              {/* Admin lock exam button */}
              {
                !exam.configuration.locked &&
                userData.role.toLowerCase() === 'administrator' &&
                settings.requireManagerExamApproval &&

                <button
                  className="actions__btn actions__btn--secondary"
                  onClick={() => onLockExam(exam.sid, exam.configuration.sid)}
                >
                  <icons.iconLock />
                  {translation.lock}
                </button>
              }

              {/* Edit exam button */}
              {!exam.configuration.locked &&
                <Link
                  iamAction="sp:ModifyExam"
                  iamResource={[
                    `ssrn:ss:sp:us-east:${userData.installSid}:course/${userData.courseSid}`,
                    `ssrn:ss:sp:us-east:${userData.installSid}:exam/${exam.sid}`
                  ]}
                  to={`exams/edit/${exam.sid}`}
                  className="actions__btn actions__btn--secondary"
                >
                  <icons.iconEdit />
                  {translation.edit}
                </Link>
              }

              {/* View exam details button */}
              <Link
                iamAction="sp:DescribeExam"
                iamResource={[
                  `ssrn:ss:sp:us-east:${userData.installSid}:course/${userData.courseSid}`,
                  `ssrn:ss:sp:us-east:${userData.installSid}:exam/${exam.sid}`
                ]}
                to={`exams/${exam.sid}`} className="actions__btn actions__btn--primary"
              >
                <icons.iconEye />
                {translation.view}
              </Link>
            </SessionStore.validater>
          </footer>
        </div>
      </article>
    )
  } 
})

export default InstructorExamCard;


// WEBPACK FOOTER //
// ./src/app/components/CourseDashboard/InstructorExamCard.js